/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-08 11:15:25
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-13 17:09:36
 */

import { createSelector } from "reselect";
import { IActivityInfo } from "../../service/activity/interface";
import { keep2Decimal } from "../../utils/number";
import { ICommonStore } from "./reducer";

export const commonStoreSelector = (state: any): ICommonStore =>
  state.commonStore;

/**
 * activityInfo
 */
export const activityInfoSelector = createSelector(
  [commonStoreSelector],
  (commonStore): ICommonStore["activityInfo"] => {
    return commonStore.activityInfo;
  }
);
export const activityInfoLoadingSelector = createSelector(
  [commonStoreSelector],
  (commonStore): ICommonStore["activityInfoLoading"] => {
    return commonStore.activityInfoLoading;
  }
);
// 活动id
export const activityIdSelector = createSelector(
  [activityInfoSelector],
  (activityInfo): undefined | number => {
    if (activityInfo) {
      return activityInfo.activity_id || undefined;
    }
    return undefined;
  }
);
// 是否为对赌活动
export const isGamblingSelector = createSelector(
  [activityInfoSelector],
  (activityInfo): boolean => {
    if (activityInfo) {
      if (activityInfo.type == 1) {
        return true;
      }
    }
    return false;
  }
);
// 对赌金额（分）
export const gamblingPriceSelector = createSelector(
  [activityInfoSelector],
  (activityInfo): number => {
    if (activityInfo) {
      return activityInfo.gambling_amount || 0;
    }
    return 0;
  }
);
// 挑战完成状态 enter_status?: 0 | 1 | 2; // 报名状态 0 未报名 1已报名 2 已经完成,
export const enterStatusSelector = createSelector(
  [activityInfoSelector],
  (activityInfo): IActivityInfo["enter_status"] => {
    if (activityInfo) {
      return activityInfo.enter_status;
    }
    return undefined;
  }
);

/**
 * 对赌奖金信息
 */
export const gamblingCountSelector = createSelector(
  [commonStoreSelector],
  (commonStore): ICommonStore["gamblingCount"] => {
    return commonStore.gamblingCount;
  }
);
// 预计单人奖金（总奖金/完成人数）(分)
export const refundPriceSelector = createSelector(
  [gamblingCountSelector],
  (gamblingCount): undefined | number => {
    if (gamblingCount) {
      if (!gamblingCount.complete_count) {
        // 没有人完成
        return gamblingCount.amount;
      } else {
        return gamblingCount.amount / gamblingCount.complete_count;
      }
    }
    return undefined;
  }
);

/**
 * 模板详情
 */
export const tempDetailSelector = createSelector(
  [commonStoreSelector],
  (commonStore): ICommonStore["tempDetail"] => {
    return commonStore.tempDetail;
  }
);
export const medalsSelector = createSelector(
  [commonStoreSelector],
  (commonStore): ICommonStore["medals"] => {
    return commonStore.medals;
  }
);
// 按钮颜色
export const tempBtnColorSelecor = createSelector(
  [tempDetailSelector],
  (tempDetail): string => {
    return tempDetail.card_info.button_color || "#00bc71";
  }
);
